/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import { IBotClassMatcher } from 'generated-types';
import { BotClassMatcher } from 'object-types';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

/**
 * @description  BotClassMatcher ConfigItem class.
 * @author Akul Aggarwal
 */
export class BotClassMatcherConfigItem extends MessageItem<IBotClassMatcher> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: BotClassMatcher,
            ...args,
        };

        super(extendedArgs);
    }
}
